import _ from 'lodash'
import { buffers, TakeableChannel } from 'redux-saga'
import { actionChannel, all, call, put, select, spawn, take } from 'redux-saga/effects'

import htmlContentService from 'services/html-content/index'

import { persistHtmlContent, REQUEST_HTML_CONTENT } from './actions'

interface RequestHtmlContentPayload {
  keys: string[]
  req?: unknown
}

export function* requestHtmlContentSaga({
  payload,
}: {
  payload: RequestHtmlContentPayload
}): Generator<unknown, void, unknown> {
  const { keys, req } = payload
  const availableContent = (yield select(
    (state: { htmlContent: Record<string, string> }) => state.htmlContent,
  )) as Record<string, string>
  const newContent = _.differenceBy(keys, _.keys(availableContent))
  if (_.isEmpty(newContent)) {
    return
  }
  const responseKeys = (yield call(htmlContentService.requestSaga as (opts: unknown) => Generator, {
    payload: {
      unauthorized: true,
      req,
      urlParams: { keys: newContent },
    },
  })) as Array<{ key: string; content: string }>
  yield all(_.map(responseKeys, (pair) => put(persistHtmlContent(pair))))
}

function* listenForHtmlContentRequestsSaga(): Generator<unknown, void, unknown> {
  type RequestAction = { type: string; payload: RequestHtmlContentPayload }
  const channel = (yield actionChannel(
    REQUEST_HTML_CONTENT,
    buffers.sliding(5),
  )) as TakeableChannel<RequestAction>
  while (true) {
    const { payload } = (yield take(channel)) as RequestAction
    yield* requestHtmlContentSaga({ payload })
  }
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([spawn(listenForHtmlContentRequestsSaga)])
}
